import { api } from '../api'

export const setFavoriteLanguage = async (language: string) => {
  const { data } = await api.post('/user/language', {
    language,
  })

  return data
}
